import { Box, Button, Grid, LinearProgress, Typography } from '@mui/material';
import { generatePath, NavLink } from 'react-router-dom';
import { CircleArrowRightIcon } from '../../../assets/icons';
import { AppIcon } from '../../../components/app-icon/AppIcon';
import { useGetSignedInUser } from '../../../hooks/useGetSignedInUser';
import { APP_URLS } from '../../../routes/urls';
import { getAllProfileUrls } from '../helper';
import { profileLayoutStyles } from './styles';

export const ProfileNavigation: React.FC = ({ children }) => {
  const { currentData: data } = useGetSignedInUser();
  /**
   * URLS to student profiles pages
   */
  const profileUrls = getAllProfileUrls(data?.user?.slug);

  return (
    <Box sx={profileLayoutStyles.nav}>
      <Box sx={{ mb: 5 }}>
        <Grid container spacing={2.5} alignItems="center">
          <Grid item sx={profileLayoutStyles.navAvatar}>
            <img src={data?.user?.media} alt={`Profile Picture of ${data?.user?.full_name}`} />
          </Grid>
          <Grid item xs>
            <Typography variant="large" fontWeight="Bold">
              {data?.user?.full_name}
            </Typography>
            <Box sx={{ mt: 1, textAlign: 'right' }}>
              <Typography variant="small" fontWeight="Medium" color="success">
                {data?.user?.progress}% Profile Complete
              </Typography>
              <LinearProgress
                sx={profileLayoutStyles.progressBar}
                variant="determinate"
                value={data?.user?.progress || 0}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      {profileUrls.map((profileUrl, index) => (
        <Box key={profileUrl.section} sx={{ mb: index !== profileUrls.length - 1 ? 4 : 2.5 }}>
          <Typography sx={profileLayoutStyles.sectionName} variant="small" fontWeight="Bold" color="secondary">
            {profileUrl.section}
          </Typography>
          <Box sx={profileLayoutStyles.navList}>
            {profileUrl.urls.map((url) => (
              <Button
                key={url.path}
                sx={profileLayoutStyles.navLink}
                component={NavLink}
                to={url.path}
                startIcon={<AppIcon Icon={url.Icon} />}
                end
              >
                {url.label}
              </Button>
            ))}
          </Box>
        </Box>
      ))}
      <Box sx={profileLayoutStyles.applySection}>
        <Button
          sx={[profileLayoutStyles.navLink, profileLayoutStyles.applyBtn]}
          component={NavLink}
          to={generatePath(APP_URLS.applyToMultiplePrograms, { studentSlug: data?.user?.slug })}
          endIcon={<AppIcon Icon={CircleArrowRightIcon} />}
          end
        >
          Apply to Multiple Programs
        </Button>
        <Button
          sx={[profileLayoutStyles.navLink, profileLayoutStyles.applyBtn]}
          component={NavLink}
          to={generatePath(APP_URLS.applyToMultipleScholarships, { studentSlug: data?.user?.slug })}
          endIcon={<AppIcon Icon={CircleArrowRightIcon} />}
          end
        >
          Apply to Multiple Scholarships
        </Button>
      </Box>
      {children}
    </Box>
  );
};
